const SERVER_API_URL = process.env.REACT_APP_SERVER_API_URL;
const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const GMAPS_API_KEY = process.env.REACT_APP_GMAPS_API_KEY;
const IMAGE_URL = process.env.REACT_APP_PRODUCT_IMAGE_BASE_URL;
const QR_URL = process.env.REACT_APP_VMQRCODE_IMAGE_BASE_URL;

export {
  SERVER_API_URL,
  SERVER_URL,
  GMAPS_API_KEY,
  IMAGE_URL,
  QR_URL,
};
